import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";

export default function Pagination({ pageCount, setStartOffset, itemsPerPage}) {

    const pageChangeHandler = (e) => setStartOffset(e.selected * itemsPerPage)

    return (
        <ReactPaginate
            breakLabel="..."
            nextLabel="Next"
            onPageChange={pageChangeHandler}
            pageCount={pageCount}
            pageRangeDisplayed={1}
            marginPagesDisplayed={1}
            previousLabel="Previous"
            containerClassName="pagination pagination-sm float-end"
            pageClassName="page-item"
            pageLinkClassName="page-link theme-clr-1 shadow-none border"
            previousClassName="page-item"
            previousLinkClassName="page-link theme-clr-1 shadow-none"
            nextClassName="page-item"
            nextLinkClassName="page-link theme-clr-1 shadow-none"
            breakClassName="page-item"
            breakLinkClassName="page-link theme-clr-1 shadow-none"
            activeClassName="active"
            activeLinkClassName="theme-bg-1_"
        />
    )
}

export const PagiSearch = ({ setSearch, setStartOffset, totalEntries, setTableDataStatus,totalDebitAmount,totalCreditAmount ,totalAmount }) => {

    const [changeVal, setChangeVal] = useState(0);
  
    useEffect(() => {
      if (totalEntries < 1) {
        setTableDataStatus('Not Found')
      }
    }, [changeVal])
  
    const searchHandler = (e) => {
      setSearch(e.target.value)
      setChangeVal(e.target.value)
      setStartOffset(0)
      document.querySelector('.pagination').children[1].querySelector('a').click();
    }
    // console.log(totalAmount)
    
    return (
      <div className="row">
        <div className="col-sm-12 col-md-8 col-lg-8 col-xl-9">
          <div className="d-sm-flex">
          <h6 className="me-3">TOTAL ENTRIES :- {totalEntries}</h6>
          <div style={{    display: "flex", gap: "20px"}}>
          {totalCreditAmount !== undefined ? <h6>TOTAL CREDIT AMOUNT :- {totalCreditAmount}</h6> : ''}
          {totalDebitAmount !== undefined ? <h6>TOTAL DEBIT AMOUNT :- {totalDebitAmount}</h6> : ''}
          {totalAmount !== undefined ? <h6>TOTAL AMOUNT :- {totalAmount}</h6> : ''}
          </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4 col-xl-3">
          <input type="search" className="form-control form-control-sm shadow-none" placeholder="Search.." onChange={searchHandler} />
        </div>
      </div>
    )
}